/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const CreateDocumentOutputJsonApiModel = {
  id: "",
  document: {
    jsonApi: "hasOne",
    type: "documents",
  },
};
